import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private profileUrl = environment.apiBaseUrl + 'auth';
  private logoutUrl = environment.apiBaseUrl + 'auth/logout';
  
  constructor(private http: HttpClient) {}

  getUserProfile(): Observable<any> {
    return this.http.get(this.profileUrl);
  }

  getStoredUser(): any {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  }

  setStoredUser(user: any): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  clearStoredUser(): void {
    localStorage.removeItem('user');
  }

  logout(): Observable<any> {
    return this.http.post(this.logoutUrl, {});
  }

  getUserDetails(): Observable<any> {
    return this.http.get(`${this.profileUrl}/fetch-profile-details`);
  }

  changeProfileImage(formData: FormData): Observable<any> {
    return this.http.post(`${this.profileUrl}/change-profile-image`, formData);
  }

  getAllMenu(): Observable<any> {
    return this.http.get(`${this.profileUrl}/get-menu`);
  }
}
